
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gKf_45Ko5RZgtxjqEMlm_c25bmts0hOSOqzH6S2W6iqfwEMeta } from "/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index1dguESQGXIqIpb5PK3txopWjO0V9BHZHUDXD_455AltuUMeta } from "/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchE_ONT2wEfo00pkWqMNFK4KCXUJ7T4FjArYoEYokr_45zIMeta } from "/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index11Gk1lJUbEbWePsvVrFRPbQfpVAUEhOI8lsD5R0n2V0Meta } from "/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_935QHqAvaoSIRx4Fu7Zn3zCUdEdzbFD4xU_45RPwZF6_xn8Meta } from "/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexHXiYk7XJTa2wWixnowt5PZnUCHLXj8essFGaX3EDo68Meta } from "/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93sArsGNnYe_alkwu_FaSybO8w6ELxMQBINmBOT0Ypa0UMeta } from "/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexY8amKH8iNHYkyffxHuDkDZH_vRQ8V_IoYn8Zt63_ks8Meta } from "/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_936lja02nLY47Ej5EyswWY3_459A4E9uVK9aBX_45wamNRsskMeta } from "/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexee9VORYLzKEegVMhWewOzBrLL_W_Mnr1Aho_qqfqpQIMeta } from "/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexKeTJau8_rRrbOSj0zLGOwE6TbYmmQXVIA0KMiKfsSsoMeta } from "/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexHXiYk7XJTa2wWixnowt5PZnUCHLXj8essFGaX3EDo68Meta || {},
    component: () => import("/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexY8amKH8iNHYkyffxHuDkDZH_vRQ8V_IoYn8Zt63_ks8Meta || {},
    component: () => import("/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexee9VORYLzKEegVMhWewOzBrLL_W_Mnr1Aho_qqfqpQIMeta || {},
    component: () => import("/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexKeTJau8_rRrbOSj0zLGOwE6TbYmmQXVIA0KMiKfsSsoMeta || {},
    component: () => import("/codebuild/output/src314200219/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]